import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
var hideErrors = !!process.env.EXTRACT_REACT_TYPES_HIDE_ERRORS;

function resolveToLast(type
/*: MemberExpression | Obj | Id*/
) {
  switch (type.kind) {
    case 'id':
    case 'object':
    case 'import':
      return type;

    case 'memberExpression':
      return resolveToLast(type.object);

    default:
      if (hideErrors) {
        /* eslint-disable-next-line no-console */
        console.error("Unexpected initial type of member expression", JSON.stringify(type));
      }

      break;
  }
}

function resolveFromGeneric(type) {
  if (type.kind !== 'generic') return type;

  if (type.typeParams) {
    // If a generic type is an Array, we don't want to just return the value,
    // But also the entire type object, so we can parse the typeParams later on.
    return type;
  }

  if (type.value.kind === 'generic') {
    return resolveFromGeneric(type.value);
  }

  return type.value;
}

function reduceToObj(type) {
  var reducableKinds = ['generic', 'object', 'intersection'];

  if (type.kind === 'generic') {
    // Only attempt to reduce generic if it has a reducable value
    // Unreducable generics that have an identifier value, e.g. ElementConfig, are still valid
    // so we return early to avoid the console warn below
    return reducableKinds.includes(type.value.kind) ? reduceToObj(type.value) : [];
  } else if (type.kind === 'object') {
    return type.members;
  } else if (type.kind === 'intersection') {
    return type.types.reduce(function (acc, i) {
      return [].concat(_toConsumableArray(acc), _toConsumableArray(reduceToObj(i)));
    }, []);
  } else if (type.kind === 'typeQuery') {
    // typeQuery is not reducable so we return early to avoid the console warn below
    return [];
  }
  /* eslint-disable-next-line no-console */


  console.warn('was expecting to reduce to an object and could not', type);
  return [];
} // We explicitly want to be able to have mode in these functions,


var unaryWhiteList = ['-', '+', '!'];
var hideErrors$1 = !!process.env.EXTRACT_REACT_TYPES_HIDE_ERRORS;

function mapConvertAndJoin(array) {
  var joiner = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ', ';
  if (!Array.isArray(array)) return '';
  return array.map(function (a) {
    return convert(a);
  }).join(joiner);
}

function getKind(type) {
  switch (type.kind) {
    case 'nullable':
      return "nullable ".concat(getKind(type.arguments));

    case 'id':
      return convert(type);

    case 'exists':
    case 'typeof':
      return convert(type);

    case 'generic':
      {
        if (type.typeParams) {
          var typeParams = type.typeParams.params.map(getKind).join(', ');
          return "".concat(convert(type.value), "<").concat(typeParams, ">");
        }

        return getKind(resolveFromGeneric(type));
      }

    default:
      return type.kind;
  }
}

var converters = {
  /*
  If the value here is undefined, we can safely assume that we're dealing with
  a BooleanTypeAnnotation and not a BooleanLiteralTypeAnnotation.
  */
  "boolean": function boolean(type, mode) {
    return type.value != null ? type.value.toString() : type.kind;
  },
  exists: function exists(type, mode) {
    return "*";
  },

  /*
    If the value here is undefined, we can safely assume that we're dealing with
    a NumberTypeAnnotation and not a NumberLiteralTypeAnnotation.
    */
  number: function number(type, mode) {
    return type.value != null ? type.value.toString() : type.kind;
  },

  /*
  If the value here is undefined, we can safely assume that we're dealing with
  a StringTypeAnnotation and not a StringLiteralTypeAnnotation.
  */
  string: function string(type, mode) {
    return type.value != null ? "\"".concat(type.value.toString(), "\"") : type.kind;
  },
  custom: function custom(type, mode) {
    return type.value.toString();
  },
  any: function any(type, mode) {
    return type.kind;
  },
  "void": function _void(type, mode) {
    return 'undefined';
  },
  literal: function literal(type, mode) {
    return "".concat(type.kind);
  },
  mixed: function mixed(type, mode) {
    return type.kind;
  },
  "null": function _null(type, mode) {
    return 'null';
  },
  logicalExpression: function logicalExpression(type, mode) {
    return "".concat(convert(type.left), " ").concat(type.operator, " ").concat(convert(type.right));
  },
  unary: function unary(type, mode) {
    var space = unaryWhiteList.includes(type.operator) ? '' : ' ';
    return "".concat(type.operator).concat(space).concat(convert(type.argument));
  },
  id: function id(type, mode) {
    return type.name;
  },
  // TODO - this is not right and needs to be improved
  opaqueType: function opaqueType(type, mode) {
    return convert(type.id);
  },
  interfaceDeclaration: function interfaceDeclaration(type) {
    return convert(type.id);
  },
  typeCastExpression: function typeCastExpression(type, mode) {
    return convert(type.expression);
  },
  JSXMemberExpression: function JSXMemberExpression(type, mode) {
    return "".concat(convert(type.object), ".").concat(convert(type.property));
  },
  JSXExpressionContainer: function JSXExpressionContainer(type, mode) {
    return "{".concat(convert(type.expression), "}");
  },
  JSXOpeningElement: function JSXOpeningElement(type
  /*JSXOpeningElement*/
  , mode) {
    return "".concat(convert(type.name), " ").concat(mapConvertAndJoin(type.attributes, ' '));
  },
  JSXElement: function (_JSXElement) {
    function JSXElement(_x, _x2) {
      return _JSXElement.apply(this, arguments);
    }

    JSXElement.toString = function () {
      return _JSXElement.toString();
    };

    return JSXElement;
  }(function (type, mode) {
    return "<".concat(convert(type.value), " />");
  }),
  JSXIdentifier: function (_JSXIdentifier) {
    function JSXIdentifier(_x3, _x4) {
      return _JSXIdentifier.apply(this, arguments);
    }

    JSXIdentifier.toString = function () {
      return _JSXIdentifier.toString();
    };

    return JSXIdentifier;
  }(function (type, mode) {
    return "".concat(type.value);
  }),
  JSXAttribute: function (_JSXAttribute) {
    function JSXAttribute(_x5, _x6) {
      return _JSXAttribute.apply(this, arguments);
    }

    JSXAttribute.toString = function () {
      return _JSXAttribute.toString();
    };

    return JSXAttribute;
  }(function (type, mode) {
    return "".concat(convert(type.name), "=").concat(convert(type.value));
  }),
  binary: function binary(type, mode) {
    var left = convert(type.left);
    var right = convert(type.right);
    return "".concat(left, " ").concat(type.operator, " ").concat(right);
  },
  "function": function _function(type, mode) {
    return "(".concat(mapConvertAndJoin(type.parameters), ") => ").concat(type.returnType === null ? 'undefined' : convert(type.returnType));
  },

  /*
    TODO: Make this resolve members in a unique way that will allow us to
    handle property keys with no assigned value
  */
  objectPattern: function objectPattern(type, mode) {
    // ({ a, b }) => undefined ({a: a, b: b}) => undefined
    // ({ a = 2, b }) => undefined  ({a: a = 2, b: b })=> undefined
    return "{ ".concat(mapConvertAndJoin(type.members), " }");
  },
  rest: function rest(type, mode) {
    return "...".concat(convert(type.argument));
  },
  assignmentPattern: function assignmentPattern(type, mode) {
    return "".concat(convert(type.left), " = ").concat(convert(type.right));
  },
  param: function param(type, mode) {
    // this will not hold once we have types
    return convert(type.value);
  },
  array: function array(type, mode) {
    return "[".concat(mapConvertAndJoin(type.elements), "]");
  },
  arrayType: function arrayType(type, mode) {
    return "Array of ".concat(convert(type.type));
  },
  spread: function spread(type, mode) {
    return "...".concat(convert(type.value));
  },
  property: function property(type, mode) {
    var sameId = type.key.kind === 'id' && type.value.kind === 'id' && type.key.name === type.value.name;
    var assignmentSameId = type.value.kind === 'assignmentPattern' && type.key.kind === 'id' && type.value.left.kind === 'id' && type.key.name === type.value.left.name;

    if (sameId) {
      // If both keys are IDs we're applying syntactic sugar
      return "".concat(convert(type.key));
    } else if (assignmentSameId) {
      // If the value is an assignment pattern with a left hand ID that is the same as our type.key, just return the resolved value.
      return "".concat(convert(type.value));
    } else {
      return "".concat(convert(type.key), ": ").concat(convert(type.value));
    }
  },
  object: function object(type, mode) {
    if (type.members.length === 0) return "{}";
    return "{ ".concat(mapConvertAndJoin(type.members), " }");
  },
  memberExpression: function memberExpression(type, mode) {
    var object = resolveToLast(type.object);
    var property = convert(type.property);

    if (!object && !hideErrors$1) {
      console.error('Object property does not exist on this member expression');
      return '';
    }

    switch (object.kind) {
      case 'id':
        return "".concat(convert(type.object), ".").concat(property);

      case 'object':
        {
          var mem = object.members.find(function (m) {
            if (typeof m.key !== 'string') {
              // Issue here is that convert(key) can result in either a String type or an Id type,
              // one returns the value wrapped in quotations, the other does not.
              // We're stripping the quotations so we can do an accurate match against the property which is always an Id
              return convert(m.key).replace(/"/g, '') === property;
            }

            return m.key === property;
          });

          if (mem && mem.value) {
            return convert(mem.value);
          } else {
            console.error("".concat(property, " not found in ").concat(convert(object)));
            return 'undefined';
          }
        }

      case 'import':
        return "".concat(convert(type.object), ".").concat(property);

      default:
        console.error('failed to resolve member expression');
        return '';
    }
  },
  call: function call(type, mode) {
    var callSignature = '';

    if (type.callee.referenceIdName) {
      callSignature = type.callee.referenceIdName;
    } else if (type.callee.id) {
      callSignature = convert(type.callee.id);
    } else {
      callSignature = convert(type.callee);
    } // $FlowFixMe - this is incorrectly reading type.callee.referenceIdName as possibly not a string.


    return "".concat(callSignature, "(").concat(mapConvertAndJoin(type.args), ")");
  },
  "new": function _new(type, mode) {
    var callee = convert(type.callee);
    var args = mapConvertAndJoin(type.args);
    return "new ".concat(callee, "(").concat(args, ")");
  },
  variable: function variable(type, mode) {
    var val = type.declarations[type.declarations.length - 1];

    if (val.value) {
      return convert(val.value);
    }

    return convert(val.id);
  },
  templateExpression: function templateExpression(type, mode) {
    return "".concat(convert(type.tag));
  },
  templateLiteral: function templateLiteral(type, mode) {
    var str = type.quasis.reduce(function (newStr, v, i) {
      var quasi = convert(v);
      var newStrClone = newStr;
      newStrClone = "".concat(newStrClone).concat(quasi);

      if (type.expressions[i]) {
        var exp = convert(type.expressions[i]);
        newStrClone = "".concat(newStrClone, "${").concat(exp, "}");
      }

      return newStrClone;
    }, '');
    return "`".concat(str, "`");
  },
  templateElement: function templateElement(type, mode) {
    return type.value.cooked.toString();
  },
  "class": function _class(type, mode) {
    return convert(type.name);
  },
  // We should write these
  generic: function generic(type, mode) {
    var typeParams = type.typeParams ? convert(type.typeParams) : '';
    var value = convert(type.value);
    return "".concat(value).concat(typeParams);
  },
  intersection: function intersection(type, mode) {
    return "".concat(mapConvertAndJoin(type.types, ' & '));
  },
  nullable: function nullable(type, mode) {
    return "?".concat(convert(type.arguments));
  },
  typeParam: function typeParam(type, mode) {
    return "".concat(type.name);
  },
  typeParams: function typeParams(type, mode) {
    return "<".concat(mapConvertAndJoin(type.params, ', '), ">");
  },
  typeParamsDeclaration: function typeParamsDeclaration(type, mode) {
    return "<".concat(mapConvertAndJoin(type.params, ', '), ">");
  },
  "typeof": function _typeof(type, mode) {
    return type.name ? "typeof ".concat(type.name) : "".concat(type.type.kind);
  },
  union: function union(type, mode) {
    return "".concat(mapConvertAndJoin(type.types, ' | '));
  },
  "import": function _import(type, mode) {
    if (type.name === 'default') {
      return "".concat(type.moduleSpecifier);
    } else {
      return "".concat(type.moduleSpecifier, ".").concat(type.name);
    }
  },
  "export": function _export(type, mode) {
    if (type.exports.length === 1) {
      return convert(type.exports[0]);
    } else {
      console.warn("kind2string has received an export type with multiple exports, and have no way of printing this.\nThe exports we found were: ".concat(type.exports.map(function (xport) {
        return convert(xport);
      }).join(', '), "\nfrom file: ").concat(convert(type.source)));
      return '';
    }
  },
  exportSpecifier: function exportSpecifier(type, mode) {
    return convert(type.exported);
  },
  // TS
  tuple: function tuple(type, mode) {
    return "[".concat(mapConvertAndJoin(type.types), "]");
  },
  typeQuery: function typeQuery(type) {
    return type.exprName ? "typeof ".concat(type.exprName.name) : "".concat(type.kind);
  }
};

function convert(type) {
  if (!type) {
    console.error('No type argument has been passed in');
    return '';
  }

  var converter = converters[type.kind];

  if (!converter) {
    if (!type.kind) {
      console.error('convert was passed an object without a kind', type);
    } else {
      console.error('could not find converter for', type.kind);
    }
  } else {
    return converter(type);
  }

  return '';
}

export default convert;
export { converters, getKind, reduceToObj, resolveFromGeneric };